<section class="top flex-row v-center jc-between mb-2">
  <div class="left flex-row gap-05">
    <div>
      <div class="flex-row gap-05">
        <img src="/icons/magellan_icon.svg" alt="Magellan Icon" />
        <h3>Magellan</h3>
      </div>
      <p class="journey-p no-margin no-padding bolder">Journey Planner</p>
    </div>
    <p class="mt-3 version">{{ appVersion }}</p>
  </div>
  <div class="right flex-row gap-05">
    <wl-button id="helpButton" [config]="helpButton" routerLink="/help"></wl-button>

    @if (!isLoginView()) {
      <div class="v-hr"></div>
      <div class="account-menu-wrapper" #accountMenuWrapper>
        <wl-button
          id="accountButton"
          [config]="accountButtonConfig()"
          [attr.aria-expanded]="isAccountMenuOpen()"
          [attr.aria-haspopup]="'menu'"
          (buttonClick)="onToggleAccountMenu()"
        ></wl-button>

        @if (isAccountMenuOpen()) {
          <div
            class="account-menu"
            role="menu"
            tabindex="-1"
            (click)="$event.stopPropagation()"
            (keydown.esc)="onCloseAccountMenu()"
          >
            @for (item of accountMenuItems; track item.label) {
              <button
                type="button"
                class="account-menu-item"
                role="menuitem"
                (click)="item.action()"
                (keydown.enter)="item.action()"
                (keydown.space)="item.action()"
              >
                <mat-icon>{{ item.icon }}</mat-icon>
                <span>{{ item.label }}</span>
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
</section>
